import { render, staticRenderFns } from "./DeviceMaster.vue?vue&type=template&id=10507772&scoped=true&"
import script from "./DeviceMaster.vue?vue&type=script&lang=js&"
export * from "./DeviceMaster.vue?vue&type=script&lang=js&"
import style0 from "./DeviceMaster.vue?vue&type=style&index=0&id=10507772&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10507772",
  null
  
)

export default component.exports